<template>
    <div :class="['empty-tips', `empty-tips-${size}`]" v-if="show">
        <img v-if="size==='tiny'" src="~images/empty-tiny.png" alt="empty">
        <img v-else src="~images/empty.png" alt="empty">
        <p class="text"><slot>亲，该页面暂时没有内容！</slot></p>
    </div>
</template>
<script type="text/javascript">
    export default {
        name: 'emptyTip',
        props: {
            show: {
                type: Boolean,
                'default': true
            },
            size: {
                type: String,
                'default': 'normal' // tiny/normal
            }
        }
    }
</script>
<style type="text/css" lang="scss" scoped>
    .empty-tips {
        text-align : center;
        padding    : 120px 0;
        > .text {
            margin-top : 15px;
            font-size  : 20px;
            color      : #555;
        }
        &-tiny {
            padding : 10px 0;
            > .text {
                font-size : 14px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// empty.vue?23b959dc